/** Shared Tailwind class strings for the Barmaid design system */

export const pageTitle = "font-display text-3xl font-bold tracking-tight";
export const pageSubtitle = "text-sm text-muted-foreground mt-1";
export const sectionTitle = "font-display text-lg font-semibold";
export const labelText = "text-xs font-medium text-muted-foreground";

const borderSubtle = "border-[var(--border-subtle)]";

export const cardClass = `rounded-2xl bg-surface border ${borderSubtle} shadow-card`;

export const btnPrimary =
  "inline-flex items-center justify-center gap-2 rounded-xl bg-brand-gradient px-5 py-2.5 text-sm font-semibold text-white shadow-glow transition hover:brightness-110 active:brightness-95 disabled:pointer-events-none disabled:opacity-50";

export const btnPrimaryLg =
  "inline-flex items-center justify-center gap-2 rounded-xl bg-brand-gradient px-6 py-3 text-base font-semibold text-white shadow-glow transition hover:brightness-110 active:brightness-95";

export const btnSecondary =
  "inline-flex items-center justify-center rounded-xl bg-surface-light border border-[var(--border-subtle)] px-4 py-2 text-sm font-medium text-foreground transition hover:border-accent/40 hover:shadow-glow disabled:opacity-50";

export const btnSecondaryLg =
  "inline-flex items-center justify-center rounded-xl bg-surface-light border border-[var(--border-subtle)] px-6 py-3 text-base font-medium text-foreground transition hover:border-accent/40 hover:shadow-glow";

export const btnGhost =
  "inline-flex items-center justify-center rounded-xl px-4 py-2 text-sm text-muted-foreground transition hover:bg-surface hover:text-foreground";

export const sectionHeading =
  "font-display text-3xl sm:text-4xl font-bold tracking-tight text-foreground";

export const sectionSubheading =
  "mt-3 text-base sm:text-lg text-muted-foreground max-w-2xl";

export const linkAccent =
  "font-medium text-accent underline underline-offset-2 hover:text-accent/80";
